import { Dialog } from "@headlessui/react";
import Button from "../../components/button/Button";
import {Modal, ModalTitle} from "../../components/modal/Modal";
import { ModalProp } from "../../components/modal/Modal";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";

type CompanySelectModalProps = {
  onCompanySubmit: React.FormEventHandler<HTMLFormElement>;
  columns: GridCol[];
  rowList: GridRow[];
  onSearch: (e: any) => void;
};

export const CompanySelectModal = ({
  open,
  toggle,
  closeOnClickOutside,
  onCompanySubmit,
  onSearch,
  columns,
  rowList,
}: ModalProp & CompanySelectModalProps) => {

  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
        <div className="px-2 -mt-8 pb-4 sm:p-4">
          <ModalTitle mainTitle="団体の選択" subTitle="配信する団体を選択してください"/>
          <div className="my-4 flex space-x-2 items-center">
            <div className="relative flex focus-within:z-10">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <MagnifyingGlassIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </div>
              <input
                onChange={onSearch}
                className="w-64 rounded-md pl-10 focus:border-indigo-500 focus:ring-indigo-500 border px-3 py-2 border-gray-300 shadow-sm sm:text-sm "
                placeholder="団体名で検索"
              />
            </div>
            <div>
              ※2文字以上の入力で検索できます。
            </div>
          </div>
        </div>
        <div className="h-[calc(100vh_-_24rem)] overflow-auto px-4">
          <TableList
            gridCol={columns}
            gridRow={rowList}
            sort={true}
            footer={false}
          />
        </div>
        <div className="p-4 bg-gray-100">
          <div className="flex justify-end">
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={'キャンセル'}
            />
            <Button
              className="mt-1 w-[132px]"
              children={'登録'}
              onClick={(e) => onCompanySubmit(e.nativeEvent)}
            />
          </div>
        </div>
      </Dialog.Panel>
    </Modal>
  );
};
